import React, { Component } from "react";
import { Galleria } from "primereact/galleria";
import { withTranslation } from "react-i18next";
import CommonFunctions from "../Utils/CommonFunctions";
import { Link, Navigate, useNavigate } from "react-router-dom";
import ModelBuilder from "../Components/Modal/ModelBuilder";

class Header extends Component {
  constructor(props) {
    super(props);
    const { t } = this.props;
    let urlParams = new URLSearchParams(window.location.search);
    this.lang = CommonFunctions.getSelectedLanguage();
    let myParam = urlParams.get("mobile");
    this.themesource =
      this.props.ThemePage == undefined
        ? ""
        : this.props.ThemePage.toLowerCase();
    this.state = {
      storyMapId: this.props.portalurl,
      language: this.lang, // get the selected language
      images:
        this.lang == "ar" ? this.props.Images.toReversed() : this.props.Images,
      BGImage:
        typeof this.props.Images != "undefined"
          ? this.props.Images[0].BackgroundImageUrl
          : process.env.REACT_APP_BASE_URL + this.props.BGImage,
      numVisible:
        typeof this.props.Images != "undefined"
          ? this.props.Images[0].NoOfItemsToDisplay
          : 0,
      ThemeTitle:
        typeof this.props.Images != "undefined"
          ? this.props.Images[0].ThemeTitle
          : this.props.Title,
      activeIndex: this.lang == "ar" ? this.props.Images?.length - 1 : 0,
      Header: myParam == "yes" ? false : true,
    };

    this.onThumbnailChange = this.onThumbnailChange.bind(this);
    this.onItemChange = this.onItemChange.bind(this);
    this.onTouchStart = this.onTouchStart.bind(this);
    this.onTouchEnd = this.onTouchEnd.bind(this);
    // this.arabicGalleria = this.arabicGalleria.bind(this);
    this.onItemClick = this.onItemClick.bind(this);
    this.responsiveOptions = [
      {
        breakpoint: "1400px",
        numVisible: 4,
      },
      {
        breakpoint: "1200px",
        numVisible: 4,
      },
      {
        breakpoint: "1024px",
        numVisible: 3,
      },
      {
        breakpoint: "960px",
        numVisible: 3,
      },
      {
        breakpoint: "768px",
        numVisible: 2,
      },
      {
        breakpoint: "568px",
        numVisible: 1,
      },
    ];
    this.setState({
      activeIndex: this.lang == "ar" ? this.props.Images?.length - 1 : 0,
    });
  }

  // for hamburger menu expand collapse
  menuOnClick(e) {
    var temp = document.getElementsByClassName("p-galleria-thumbnail-next");
    if (this.state.language == "ar") {
      temp = document.getElementsByClassName("p-galleria-thumbnail-prev");
    }
    for (var i = 0; i < temp.length; i++) {
      temp[i].classList.toggle("hidenext");
    }
    document.getElementById("menu").classList.toggle("menu_width");
    document.getElementById("menu-bar").classList.toggle("change");
    document.getElementById("nav").classList.toggle("change");
    document.getElementById("menu-bg").classList.toggle("change-bg");
  }
  //for Search
  Search() {
    let searchvalue = document.getElementById("searchvalue").value;
    if (searchvalue == "" || searchvalue == null) {
      return false;
    }
    window.location.href =
      process.env.REACT_APP_BASE_URL + "/Search/" + searchvalue;
    return false;
  }
  //for search event on keypress
  Searchkeypress(event) {
    if (event.which == 13) {
      this.Search();
    }
  }
  //For language selection
  languagesel(e) {
    CommonFunctions.changeLanguage(e);
  }
  onItemClick(event) {
    let target = event.target;
    if (target.childNodes.length > 0) {
      let classList = [...event.target.classList];
      let index = classList.indexOf("p-link");
      //change on menu outside click issue commented the code 2023-05-16
      if (event.target.tagName.toLowerCase() == "h2") {
        window.scrollTo({ top: 400, behavior: "smooth" });
      }
      //change on menu outside click 2023-05-16
    } else if (target.childNodes.length == 0) {
      let classList = [...event.target.classList];
      let index = classList.indexOf("pi");
      if (index == -1) {
        window.scrollTo({ top: 400, behavior: "smooth" });
      }
    }
  }
  //For thumnail item change
  onItemChange(event) {
    // console.log("onItemChange index:", event.index);
    this.setState({
      activeIndex: event.index,
    });
    //Start change 2023-05-15
    // if (this.state.language == "ar") {
    //   setTimeout(
    //     function () {
    //       var element = document
    //         .getElementById("headergalleria")
    //         .getElementsByClassName("p-galleria-thumbnail-items");
    //       var elementStyle = element[0].style;
    //       if (elementStyle.cssText != "") {
    //         var split = elementStyle.cssText.split("translate3d(");
    //         var split1 = split[1].split("%");
    //         var split2 = Math.abs(parseInt(split1[0]));
    //         elementStyle.cssText =
    //           "transform: translate3d(" +
    //           split2 +
    //           "%, 0px, 0px); transition: transform 50ms ease 0s;";
    //       }
    //     }.bind(this),
    //     //this.arabicGalleria()
    //     10
    //   );
    // }
    // if (event.index >= 1 && this.activeIndex ) {
    //   window.scrollTo({ top: 400, behavior: "smooth" });
    // }
    // var element = document.getElementById("theme_ani");
    //element.classList.remove("w3-animate-bottom");
    //element.setAttribute("class","w3-animate-bottom");

    // window.scroll(0, 301)
    //Start change 2023-05-15
  }
  onThumbnailChange(event) {
    // console.log("onThumbnailChange index:", event.index);
    this.setState({
      activeIndex: event.index,
    });
  }

  //for arbic changes
  // arabicGalleria() {
  //   var element = document
  //     .getElementById("headergalleria")
  //     .getElementsByClassName("p-galleria-thumbnail-items");
  //   var elementStyle = element[0].style;

  //   if (elementStyle.cssText != "") {
  //     var split = elementStyle.cssText.split("translate3d(");
  //     var split1 = split[1].split("%");
  //     var split2 = Math.abs(parseInt(split1[0]));
  //     // var split2 = parseInt(split1[0]);
  //     elementStyle.cssText =
  //       "transform: translate3d(" +
  //       split2 +
  //       "%, 0px, 0px); transition: transform 500ms ease 0s;";
  //   }
  // }
  //For thumnail item change on mobile
  onTouchStart(e) {
    var touchobj = e.target;
    var srcpath = e.target.getAttribute("srcpath");
    if (srcpath != "" && srcpath != null && srcpath != undefined) {
      this.props.navigate(srcpath);
    }
  }
  onTouchEnd(e) {
    var target = e.target;
    if (
      target.innerText != "" ||
      (target.currentSrc != "" && target.currentSrc != undefined)
    ) {
      var currenttarget = target.closest(".p-galleria-thumbnail-item-content");
      if (currenttarget == null) {
        return;
      }
      var currentid = currenttarget.firstChild.id;
      currenttarget
        .closest(".p-galleria-thumbnail-item")
        .classList.add("p-galleria-thumbnail-item-current");
      var index = currentid == "0" ? 0 : currentid - 1;
      setTimeout(
        function () {
          this.setState({
            activeIndex: index,
          });
          //Start change 2023-05-15
          if (this.state.language == "ar") {
            setTimeout(
              function () {
                // this.arabicGalleria();
              }.bind(this),
              10
            );
          }
          //Start change 2023-05-15
        }.bind(this),
        10
      );
    }
  }
  thumbnailTemplate(item) {
    return (
      <Link to={item.href} id={item.id}>
        <div className="product-item">
          <div className="product-item-content">
            <div>
              <img
                src={process.env.REACT_APP_BASE_URL + item.itemImageSrc}
                srcpath={item.href}
                alt=""
                title={item.title}
                className="img_bx"
              />
              <h2 srcpath={item.href} title={item.title}>
                {item.title}
              </h2>
            </div>
          </div>
        </div>
      </Link>
    );
  }

  componentDidUpdate(prevProps) {
    if (this.props.activeindex != prevProps.activeindex) {
      let urlParams = new URLSearchParams(window.location.search);
      let myParam = urlParams.get("mobile");
      if (myParam == "yes") {
        this.setState({ Header: false });
      }
      this.setState({
        activeIndex:
          this.lang == "ar"
            ? this.props.Images.length - 1 - this.props.activeindex
            : this.props.activeindex,
      });
    }
  }

  componentDidMount() {
    // console.log("Header component mounted");
    let theme = CommonFunctions.renderThemeName();
    let urlParams = new URLSearchParams(window.location.search);
    let myParam = urlParams.get("mobile");
    if (myParam == "yes") {
      this.setState({ Header: false });
    } else {
      window.HeadrRoom();
    }
    if (theme == null) return;

    // if (this.state.language == "ar") {
    //   this.setState({ activeIndex: this.props.activeindex });
    //   //Start change 2023-05-15
    //   setTimeout(
    //     function () {
    //       // this.arabicGalleria();
    //     }.bind(this),
    //     50
    //   );
    //   //Start change 2023-05-15
    // } else {
    //   this.setState({ activeIndex: this.props.activeindex });
    // }
    this.setState({
      activeIndex:
        this.lang == "ar"
          ? this.props.Images.length - 1 - this.props.activeindex
          : this.props.activeindex,
    });
  }

  render() {
    const { t } = this.props;
    var ThemesInfo = this.props.ThemesInfo;
    var ThemesItems = [];
    for (var i = 0; i < ThemesInfo.length; i++) {
      ThemesItems.push(
        <li className="sidebar-item act menuclose">
          <Link to={ThemesInfo[i].href} className="sidebar-anchor menuclose">
            {ThemesInfo[i].ThemeTitle}
          </Link>
        </li>
      );
    }

    return (
      <div>
        {this.state.Header && (
          <header dir={t("direction")}>
            <nav
              id="header"
              className="navbar navbar-light amber lighten-4 "
              style={{ zIndex: 100 }}
            >
              <div id="search-form">
                <div className="search-box">
                  <button
                    type="button"
                    className="btn-search"
                    onClick={this.Search.bind(this)}
                  >
                    <i className="fas fa-search"></i>
                  </button>
                  <input
                    type="search"
                    name="search"
                    onKeyDownCapture={this.Searchkeypress.bind(this)}
                    id="searchvalue"
                    className="input-search"
                    placeholder={t("typetosearch")}
                  />
                </div>
              </div>

              <div id="menu" className="menuclose">
                <div
                  id="menu-bar"
                  className="menuclose cl_close"
                  onClick={this.menuOnClick.bind(this)}
                >
                  <div id="bar1" className="bar menuclose"></div>
                  <div id="bar2" className="bar menuclose"></div>
                  <div id="bar3" className="bar menuclose"></div>
                </div>
                <nav className="nav menuclose" id="nav">
                  <ul className="sidebar-list menuclose">
                    {ThemesItems}
                    <li className="sidebar-item act menuclose">
                      {/* <Link
                        to="/ContactUs"
                        className="sidebar-anchor menuclose"
                      >
                       <i class="fa-solid fa-quote-right"></i> {t("citeme")}
                      </Link>  */}
                      <ModelBuilder />
                    </li>
                  </ul>
                  <ul className="nav-social menuclose">
                    <li className="cite_di">
                      <Link to="/ContactUs" className="cite_btn">
                        {t("ContactUs")}
                      </Link>
                    </li>

                    <li className="menuclose">
                      <a
                        href="https://twitter.com/fgic_uae"
                        target="_blank"
                        className="menuclose"
                      >
                        <i className="fab fa-twitter"></i>
                      </a>
                    </li>
                    <li className="menuclose">
                      <a
                        href="https://www.instagram.com/fgic_uae"
                        target="_blank"
                        className="menuclose"
                      >
                        <i className="fab fa-instagram"></i>
                      </a>
                    </li>
                    <li className="menuclose">
                      <a
                        href="https://wa.me/971547240288"
                        target="_blank"
                        className="menuclose"
                      >
                        <i className="fab fa-whatsapp"></i>
                      </a>
                    </li>
                  </ul>
                </nav>
              </div>
              <Link className="navbar-brand nav-link " to="/Index">
                <img
                  src={process.env.REACT_APP_BASE_URL + "/images/FGIC_Logo.svg"}
                  className="logo-display"
                  alt="FGIC"
                />
              </Link>

              {/*<form id="search-form" action=""  style={{marginRight:"24rem"}}>
                   <div class="input-group" style={{backgroundColor: "#fff"}}>
                   <div class="form-outline">
                     <input type="search" required="required" name="search" id="searchvalue" class="form-control" />
                     <label class="form-label" for="form1">Search</label>
                   </div>
                   <button type="button" class="btn btn-primary" onClick={this.Search.bind(this)}>
                     <i class="fas fa-search"></i>
                   </button>
                 </div>
                 </form> */}

              <div className="languagebar">
                <a
                  className="cursor_pointer"
                  style={
                    this.state.language == "en"
                      ? { color: "#fff", background: "#ec6e3c" }
                      : { color: "#fff", background: "#343538" }
                  }
                  onClick={this.languagesel.bind(this)}
                >
                  ENGLISH
                </a>
                <a
                  className="cursor_pointer arab_br"
                  style={
                    this.state.language == "ar"
                      ? { color: "#fff", background: "#ec6e3c" }
                      : { color: "#fff", background: "#343538" }
                  }
                  onClick={this.languagesel.bind(this)}
                >
                  العربية
                </a>
              </div>

              <div className="menu-bg menuclose overlay-bg" id="menu-bg"></div>
            </nav>

            <div
              className="inner_bg-image"
              style={{ backgroundImage: "url(" + this.state.BGImage + ")" }}
            >
              <div className="mask gradient_header">
                <div className="header_title">
                  <h1
                    className="text-white"
                    data-aos="fade-down"
                    data-aos-delay="5"
                  >
                    {" "}
                    {this.state.ThemeTitle}
                  </h1>
                </div>
                <div
                  // dir={

                  //   this.state.language == "ar" ? "rtl" : "ltr"
                  // }
                  className="d-flex justify-content-center align-items-center banr_txt"
                >
                  <div
                    className="container-fluid"
                    data-aos="fade-left"
                    data-aos-delay="10"
                  >
                    <Galleria
                      ref={(el) => (this.galleria = el)}
                      value={this.state.images}
                      activeIndex={this.state.activeIndex}
                      responsiveOptions={this.responsiveOptions}
                      numVisible={this.state.numVisible}
                      id="headergalleria"
                      className={
                        "container headergallerila header_" + this.themesource
                      }
                      thumbnail={this.thumbnailTemplate}
                      circular={true}
                      onThumbnailChange={this.onThumbnailChange}
                      onItemChange={this.onItemChange}
                      onTouchStart={this.onTouchStart}
                      onTouchEnd={this.onTouchEnd}
                      onClick={this.onItemClick}
                    />
                  </div>
                </div>
              </div>
            </div>
          </header>
        )}
      </div>
    );
  }
}
function WithNavigate(props) {
  let navigate = useNavigate();
  return <Header {...props} navigate={navigate} />;
}
export default withTranslation()(WithNavigate);
